// extracted by mini-css-extract-plugin
module.exports = {"content":"dp-0F6U2Iuy","title":"dp-VTJcXZxd","desction":"dp-P35qJ0lO"};